import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Gateway} from "../../../../../models/gateway/Gateway";
import {BaseComponent} from "../../../../BaseComponent";
import {GatewayType} from "../../../../../models/gateway-type/GatewayType";
import {SendingCronFrequencyEnum} from "../../../../../enums/registry/SendingCronFrequencyEnum";
import {NetConfig} from "../../../../../models/gateway/NetConfig";
import {DxFormComponent} from "devextreme-angular";

@Component({
  selector: 'app-gateway-edit-form',
  templateUrl: './gateway-edit-form.component.html',
  styleUrls: ['./gateway-edit-form.component.css', '../../gateway-device.component.css', '../../../../common/drawer-style.css', '../../../base-component-with-drawer.component.css']
})
export class GatewayEditFormComponent extends BaseComponent {

  @Input() editedGateway!: Gateway;
  @Input() selectedGateway?: Gateway;
  @Input() gatewayEditTextOptions: any;
  @Input() gatewayEditTextAreaOptions: any;
  @Input() gatewayEditNumberOptions: any;
  @Input() gatewayEditCheckBoxOptions: any;
  @Input() gatewayTypes: GatewayType[];
  @Input() isEditMode!: boolean;
  @Input() selectedGatewayNetConfig?: NetConfig[];

  @Output() isEditFormValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() gatewayEdited: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('editGatewayForm', {static: false}) public editGatewayForm!: DxFormComponent;

  protected sendingCronFrequencyValues: string[];

  constructor() {
    super();
    this.gatewayTypes = [];
    this.sendingCronFrequencyValues = Object.values(SendingCronFrequencyEnum);
  }

  /**
   * Check if edited gateway is valid, to enable SAVE button
   */
  checkEditGatewayValidation() {
    if (this.editGatewayForm) {
      const result = this.editGatewayForm.instance.validate();

      this.isEditFormValid.emit(result.isValid);
      this.gatewayEdited.emit(this.isEditMode && JSON.stringify(this.editedGateway) !== JSON.stringify(this.selectedGateway));
      this.appService.setRegistryEntityIsChanged(this.gatewayEdited && this.isEditMode);

    }
  }

  getAcquisitionCronLabel = (acquisitionCron: string) => {
    return this.translate.instant('FREQUENCY.' + acquisitionCron);
  };

}
